import BaseListPage from "../../../../base/BaseListPage";
import ExcelJS from "exceljs";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import TotalSalesDayPresenter from "./TotalSalesDayPresenter.js";
import Export from "../../../../components/Export/index.js";
import printChart from "../../../../PrintChart.js";
import { Progress } from "../../../../nq-component";
import DefaultState from "../../../sales-and-transactions/components/DefaultState.js";
import Select from "react-select";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import InitialPrompt from "../../../../components/InitialPrompt/index.js";
import HighchartsSalesReport from "./components/HighchartsSalesReport.js";
import ProgressLoader from "../../../../components/ProgressLoader/index.js";
import DateRangeReport from "../../../../components/DateRangeReport/index.js";
import PageHeader from "../../../../components/PageHeader/index.js";
import CustomSelect from "../../../../components/CustomSelect/index.js";

class TotalSalesDayPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TotalSalesDayPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );

    this.state = {
      objects: [],
      isShow: false,
      selectedDate: new Date().toISOString().split("T")[0],
      selectedStoreCode: "",
      totalSalesPerHour: [],
      totalTransactionsPerHour: [],
      storess: "",
      store: [],
      notFound: false,
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", ""),
    );
    return [...new Set(storeCodes)];
  }

  filterTransactions(transactions) {
    const selectedDate = new Date(this.state.selectedDate);
    selectedDate.setHours(5, 0, 0, 0);

    const endDate = new Date(selectedDate);
    endDate.setDate(endDate.getDate() + 1);
    endDate.setHours(4, 59, 59, 999);

    return transactions
      .filter((status) => status.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.tran_date);

        const selectedDateMatch =
          transactionDate >= selectedDate && transactionDate <= endDate;
        const storeCodeMatch = this.state.selectedStoreCode
          ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
            this.state.selectedStoreCode
          : true;

        // return selectedDateMatch && storeCodeMatch;
        return true;
      });
  }

  handleDateChange(event) {
    const selectedDate = event.target.value;
    console.log("SSSELECTED", selectedDate);
    const formattedDate = this.formatDate(selectedDate);
    this.setState({ selectedDate: event.target.value, isShow: true });
    this.presenter.onChangeDate(formattedDate);
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  formatDate(dateString) {
    const date = new Date(dateString);

    // Start date (same day at 05:00:00.000)
    const startTime = new Date(date);
    startTime.setHours(5, 0, 0, 0);
    const formattedStartTime = this.formatDateToCustom(startTime);

    // End date (next day at 04:59:00.000)
    const endTime = new Date(date);
    endTime.setDate(endTime.getDate() + 1); // Move to the next day
    endTime.setHours(4, 59, 0, 0);
    const formattedEndTime = this.formatDateToCustom(endTime);

    return {
      tran_date: {
        $gte: formattedStartTime,
        $lte: formattedEndTime,
      },
    };
  }

  formatDateToCustom(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  calculateAverageSales(transactions) {
    const averageSales = new Array(24).fill(0);
    const hourCounts = new Array(24).fill(0);
    const totalTransactionsPerHour = new Array(24).fill(0);

    transactions.forEach((transaction) => {
      const date = new Date(transaction.tran_date);
      const hour = date.getHours();

      const index = (hour < 5 ? hour + 24 : hour) - 5;

      const grossSales = parseFloat(transaction.total);

      const sales = grossSales - parseFloat(transaction.total_tax);

      averageSales[index] += sales;
      hourCounts[index]++;
      totalTransactionsPerHour[index]++;
    });

    return { averageSales, totalTransactionsPerHour };
  }

  getChartData() {
    const filteredTransactions = this.filterTransactions(this.state.objects);

    const fill = filteredTransactions.filter((item) => item.tran_date);

    const { averageSales, totalTransactionsPerHour } =
      this.calculateAverageSales(filteredTransactions);
    if (
      JSON.stringify(this.state.totalSalesPerHour) !==
      JSON.stringify(averageSales)
    ) {
      this.setState({ totalSalesPerHour: averageSales });
      this.setState({ totalTransactionsPerHour });
    }
    const labels = Array.from({ length: 24 }, (_, i) => {
      const hour = (5 + i) % 24;
      return `${hour}:00`;
    });
    return {
      labels: labels, // 0 to 23, labeled as hours
      datasets: [
        {
          label: "Total Sales",
          data: averageSales,
          backgroundColor: "#006096",
          borderColor: "#006096",
          borderWidth: 1,
        },
      ],
    };
  }

  getChartOptions() {
    const filteredTransactions = this.filterTransactions(this.state.objects);
    const { averageSales, totalTransactionsPerHour } =
      this.calculateAverageSales(filteredTransactions);

    const labels = Array.from({ length: 24 }, (_, i) => {
      const hour = (5 + i) % 24;
      return `${hour}:00`;
    });

    const formattedSales = averageSales.map((sales) =>
      parseFloat(sales.toFixed(2)),
    );

    return {
      chart: {
        type: "column",
      },
      title: {
        text: "Total Sales vs. Hour of Today",
      },
      xAxis: {
        categories: labels,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: "Total Sales (PHP)",
        },
      },
      tooltip: {
        formatter: function () {
          const totalTransactions =
            totalTransactionsPerHour[this.point.index] || 0;
          return `
            <b>${this.x}</b><br/>
            Total Sales: ₱${this.y.toFixed(2)}<br/>
            Total Transactions: ${totalTransactions}
          `;
        },
      },
      series: [
        {
          name: "Total Sales",
          data: formattedSales,
          color: "#006096",
        },
      ],
    };
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  getCollectionName() {
    return "transactions";
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  getCollectionName() {
    return "transactions";
  }

  convertToCSV(objArray) {
    const array =
      typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
    let str =
      `${Object.keys(array[0])
        .map((value) => `"${value}"`)
        .join(",")}` + "\r\n";
    for (let i = 0; i < array.length; i++) {
      let line = "";
      for (let index in array[i]) {
        if (line !== "") line += ",";
        line += `"${array[i][index]}"`;
      }
      str += line + "\r\n";
    }
    return str;
  }

  exportToCSV = async () => {
    const { totalSalesPerHour, storess, range } = this.state;

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Total Sales per Hour");

    // ===== COLORS (ARGB) =====
    const TITLE_BLUE = "FF0076BA";
    const HEADER_GREEN = "FF83C14A";
    const LIGHT_GRAY = "FFF2F2F2";
    const BORDER = "FFCCCCCC";

    const borderStyle = {
      top: { style: "thin", color: { argb: BORDER } },
      left: { style: "thin", color: { argb: BORDER } },
      bottom: { style: "thin", color: { argb: BORDER } },
      right: { style: "thin", color: { argb: BORDER } },
    };

    // ===== DATE RANGE (pretty) =====
    const prettyDateRange =
      range?.tran_date?.$gte && range?.tran_date?.$lte
        ? `${new Date(range.tran_date.$gte).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })} - ${new Date(range.tran_date.$lte).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}`
        : "No date selected";

    // ===== TITLE =====
    ws.mergeCells("A1:B1");
    ws.getCell("A1").value = "Total Sales vs. Hour Of Today";
    ws.getCell("A1").font = {
      bold: true,
      size: 14,
      color: { argb: "FFFFFFFF" },
    };
    ws.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
    ws.getCell("A1").fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: TITLE_BLUE },
    };
    ws.getRow(1).height = 24;

    // ===== META =====
    ws.getCell("A2").value = "Brand";
    ws.getCell("B2").value = "Angels Pizza";

    ws.getCell("A3").value = "Store";
    ws.getCell("B3").value = storess || "All Stores";

    ws.getCell("A4").value = "Date Range";
    ws.getCell("B4").value = prettyDateRange;

    ["A2", "A3", "A4"].forEach((addr) => {
      ws.getCell(addr).font = { bold: true };
      ws.getCell(addr).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: LIGHT_GRAY },
      };
    });

    // ===== TABLE HEADER =====
    const headerRow = 6;
    ws.getRow(headerRow).values = ["Hour", "Total Sales"];
    ws.getRow(headerRow).font = { bold: true, color: { argb: "FFFFFFFF" } };
    ws.getRow(headerRow).alignment = {
      horizontal: "center",
      vertical: "middle",
    };
    ws.getRow(headerRow).height = 18;

    ws.getRow(headerRow).eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: HEADER_GREEN },
      };
      cell.border = borderStyle;
    });

    // ===== DATA ROWS =====
    let rowIndex = headerRow + 1;

    (totalSalesPerHour || []).forEach((sales, index) => {
      const hour = (5 + index) % 24; // your original mapping
      const hourLabel = `${String(hour).padStart(2, "0")}:00`;

      ws.getRow(rowIndex).values = [hourLabel, Number(sales || 0)];
      ws.getCell(`B${rowIndex}`).numFmt = "#,##0.00";

      ws.getRow(rowIndex).eachCell((cell, col) => {
        cell.border = borderStyle;
        cell.alignment =
          col === 2
            ? { horizontal: "right", vertical: "middle" }
            : { horizontal: "left", vertical: "middle" };
      });

      rowIndex++;
    });

    // ===== COLUMN WIDTHS =====
    ws.getColumn(1).width = 14; // Hour
    ws.getColumn(2).width = 18; // Total Sales

    // ===== FREEZE + FILTER =====
    ws.views = [{ state: "frozen", ySplit: headerRow }];
    ws.autoFilter = {
      from: { row: headerRow, column: 1 },
      to: { row: headerRow, column: 2 },
    };

    // ===== DOWNLOAD (no file-saver) =====
    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "total-sales-time.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const { objects, storess, selectedDate } = this.state;
    console.log("Ranage", this.state.range);
    const chartData = this.getChartData();
    const chartOptions = this.getChartOptions();
    const printId = "chart-container3";
    const formatSales = (sales) => {
      return sales.toLocaleString("en-US", {
        style: "currency",
        currency: "PHP",
      });
    };

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <PageHeader
            title="Total Sales vs. Hour Of Today"
            subtitle="Analyze total sales performance by hour for today"
            icon="bi bi-clock-history"
          />
          <Export
            exportCsv={() => this.exportToCSV()}
            exportPdf={() => printChart(printId)}
          />
        </div>
        <div className="row mb-2">
          {/* <div className="col-sm-2">
            <input
              className="form-control"
              type="date"
              onChange={this.handleDateChange}
            />
         
          </div> */}
          <div className="col" style={{ maxWidth: "max-content" }}>
            <DateRangeReport
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>
          <div className="col-sm-4">
            <CustomSelect
              label="Store"
              options={[
                // { value: "AllStore", label: "All Store" },
                ...this.state.store.map((store) => ({
                  value: store.name,
                  label: store.name.replace(/_/g, " "),
                })),
              ]}
              onChange={(selected) => this.onChangeStore(selected.value)}
              isDisabled={!this.state.range}
              error={
                !this.state.range ? "Please select a date range first" : ""
              }
              icon="bi bi-shop"
              placeholder="Select Store"
              isClearable={true}
            />
          </div>
        </div>
        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 ? (
          <HighchartsSalesReport
            chartOptions={chartOptions}
            chartData={chartData}
            formatSales={formatSales}
            storess={storess}
            selectedDate={this.state.range}
            chartRef={this.chartRef3}
            containerId="chart-container3"
          />
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess &&
          this.state?.selectedDate &&
          !this.state.notFound ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default TotalSalesDayPage;
